
    <div class="modal-inner">
      <div class="modal-header">
        <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
          <h4 class="modal-title"><strong>Nuovo ciclo {{ categoria}}</strong></h4>
        </div>
      </div>
      <div class="modal-body">
        <p>Vuoi copiare le impostazioni del precedente ciclo {{ categoria }} o crearlo da zero?</p>
      </div>
      <div class="modal-footer d-inline-block text-center">
        <div style="white-space: nowrap" class="mb-2">
          <button class="btn btn-primary btn-sm" (click)="this.modal.close('new');">Crea da zero</button>
          <button class="btn btn-primary btn-sm" (click)="this.modal.close('copy');">Copia precedente</button>
        </div>
        <button class="btn btn-default btn-sm" (click)="modal.dismiss()">Annulla</button>
      </div>
    </div>
  